/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import TextField, { TextFieldProps } from '@mui/material/TextField';

type Ref = {getValue: () => void;}

type Options = {
  systemError?: boolean
}

const FormInput = React.forwardRef<Ref, TextFieldProps & Options>((props, ref) => {
  const [value, setValue] = React.useState(props.value);
  const {
    helperText,
    systemError,
    onChange,
    ...rest
  } = props;

  React.useImperativeHandle(ref, () => ({
    getValue: () => value || undefined,
  }), [value]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value);
    if (onChange) onChange(e);
  };

  return (
    <TextField
      error={systemError ?? rest.error}
      helperText={helperText ?? ' '}
      {...rest}
      value={value || ''}
      onChange={handleChange}
    />
  );
});

export default FormInput;
